import { Button } from "@mui/material";
import { styled } from "@mui/system";

export const RoundedButtonWithText = styled(Button)`
  border-radius: 20px;
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  text-transform: capitalize;
`;